var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoutingStartAlt300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_929_3143",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_929_3143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 23.4663L23.4663 18L18 12.5337L16.4337 14.1L19.2087 16.875H12.375V19.1249H19.2087L16.4337 21.9L18 23.4663ZM18.0025 32.2499C16.0316 32.2499 14.179 31.8759 12.4448 31.1279C10.7106 30.3799 9.20208 29.3648 7.91925 28.0826C6.6364 26.8003 5.62081 25.2924 4.87249 23.559C4.12416 21.8255 3.75 19.9734 3.75 18.0025C3.75 16.0316 4.124 14.179 4.872 12.4448C5.62 10.7106 6.63513 9.20208 7.91738 7.91925C9.19965 6.6364 10.7075 5.62081 12.441 4.87249C14.1744 4.12416 16.0266 3.75 17.9975 3.75C19.9684 3.75 21.8209 4.124 23.5551 4.872C25.2893 5.62 26.7979 6.63513 28.0807 7.91738C29.3635 9.19965 30.3791 10.7075 31.1274 12.441C31.8758 14.1744 32.2499 16.0266 32.2499 17.9975C32.2499 19.9684 31.8759 21.8209 31.1279 23.5551C30.3799 25.2893 29.3648 26.7979 28.0826 28.0807C26.8003 29.3635 25.2924 30.3791 23.559 31.1274C21.8255 31.8758 19.9734 32.2499 18.0025 32.2499ZM18 30C21.35 30 24.1875 28.8375 26.5125 26.5125C28.8375 24.1875 30 21.35 30 18C30 14.65 28.8375 11.8125 26.5125 9.48746C24.1875 7.16246 21.35 5.99996 18 5.99996C14.65 5.99996 11.8125 7.16246 9.48746 9.48746C7.16246 11.8125 5.99996 14.65 5.99996 18C5.99996 21.35 7.16246 24.1875 9.48746 26.5125C11.8125 28.8375 14.65 30 18 30Z",
    fill: "#F9F9F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingStartAlt300);
export default __webpack_public_path__ + "static/media/routing_start_alt_300.0bdc5e6726b3c0f027048009128faa51.svg";
export { ForwardRef as ReactComponent };